import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaaa35c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-led" }, null, -1))

import { PropType } from 'vue';
import { PhoneLineComposable } from '../../../../ecs/phone/PhoneLine';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioLine',
  props: {
  radioLine: { type: Object as PropType<PhoneLineComposable>, required: true }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["option bg-chalk-dust-100 hover:bg-chalk-dust-300", {
      disabled: !__props.radioLine.enabled
    }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.radioLine.category.value.title), 1),
    _hoisted_2
  ], 2))
}
}

})